import { GridCellParams } from '@mui/x-data-grid-pro';
import { GridCustomColDef } from '../../types';
import { formatPrice } from '../../../utils/helpers';

export const allTimeOneTimeColumns: GridCustomColDef[] = [
  {
    field: 'id',
    headerName: '',
    headerAlign: 'left',
    align: 'left',
    cellClassName: 'grey-background',
    minWidth: 146,
    flex: 1,
    type: 'singleSelect',
    sortable: false,
    filterable: false,
    hideable: false
  },
  {
    field: 'expected',
    headerName: 'Expected',
    headerAlign: 'right',
    align: 'right',
    minWidth: 119,
    flex: 1,
    type: 'singleSelect',
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && (params.value as number) < -1 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'actual',
    headerName: 'Actual',
    headerAlign: 'right',
    align: 'right',
    minWidth: 119,
    flex: 1,
    type: 'singleSelect',
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && (params.value as number) < -1 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  },
  {
    field: 'difference',
    headerName: 'Difference',
    headerAlign: 'right',
    align: 'right',
    minWidth: 119,
    flex: 1,
    type: 'singleSelect',
    sortable: false,
    filterable: false,
    valueFormatter: (value) => formatPrice(value),
    renderCell: (params: GridCellParams) => (
      <span className={params.value && (params.value as number) < -1 ? 'text-price-red' : ''}>
        {formatPrice(params.value as number)}
      </span>
    )
  }
];
